import {default as BottomNavigatorMenuItem} from './BottomNavigatorMenuItem-Component';
export default BottomNavigatorMenuItem;
